export default "/_next/static/663764aab77a3fd564362df21e79e0a8.svg";